<template>
  <div class="result text-center">
    <h3>萬人布豐投針實驗企劃</h3>
    <v-row no-gutters class="justify-center">
      <v-col cols="6" md="6" class="board">
        <v-hover v-slot="{ hover }">
        <v-card  :elevation="hover ? 5 : 2"
          :class="{ 'on-hover': hover }">
          <v-card-text>
            <div>累計投擲次數</div>
            <p class="display-1 text--primary">{{ animated_total_throw }}</p>
          </v-card-text>
        </v-card>
        </v-hover>
      </v-col>
      <v-col cols="6" md="6" class="board">
        <v-hover v-slot="{ hover }">
        <v-card  :elevation="hover ? 5 : 2"
          :class="{ 'on-hover': hover }">
          <v-card-text>
            <div>累計相交次數</div>
            <p class="display-1 text--primary">{{ animated_total_cross }}</p>
          </v-card-text>
        </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-row no-gutters class="justify-center">
      <v-col cols="12" sm="12" class="board">
        <v-hover v-slot="{ hover }">
        <v-card  :elevation="hover ? 5 : 2"
          :class="{ 'on-hover': hover }">
          <v-card-text>
            <p class="display-1 text--primary"><katex-element expression="\\\pi\approx"/> {{ est_pi }}</p>
          </v-card-text>
        </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-row no-gutters class="justify-center">
      <v-col cols="9" sm="9" class="slider">
        <v-slider
          v-model="slider"
          max="10"
          min="0"
          step="0.1"
          thumb-label="always"
        >
          <template v-slot:thumb-label="{ value }">
            {{ value }}%
          </template>
        </v-slider>
        
      </v-col>
      <v-col cols="3" sm="3">
        <v-checkbox
      v-model="checkbox"
      v-on:change="outlier()"
      label="扣除極端值"
      class="check_outlier"
    ></v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>
<style  scoped>
.result{
  padding-top: 100px;
}
.board {
  padding-left: 10px!important;
  padding-right: 10px!important;
  padding-top:20px!important;
}
.check_outlier{
  padding-top:30px!important;

}
.slider{
  padding-top:50px!important;

}
.v-card[class*="elevation-"]:before {
  display: block;
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
}
.v-card.elevation-2:before {
  background: rgba(255, 255, 255, 0.02)
}
.v-card.elevation-5:before {
  background: rgba(255, 255, 255, 0.05)
}


</style>
<script>
  import {db} from '../plugins/firebase'; 
  import { gsap } from "gsap";

  export default {
    inject: ["eventHub"],
    name: "Result",
    data: () => ({
      total_throw:0,
      total_cross:0,
      outlier_throw:67075,
      outlier_cross:34359,
      real_throw:0,
      real_cross:0,
      temp_total_throw: 0,
      temp_total_cross: 0,
      markers:{},
      slider: 0,
      checkbox: false,
    }),
    computed: {
    // a computed getter
      factor: function(){
        return 10/10.4*(1-this.slider/100)
      },
      est_pi: function () {
        if(this.total_cross == 0){
          return '？'
        }else{
          return Math.round(2*this.total_throw.toFixed(0)/this.total_cross.toFixed(0)*this.factor*10000000)/10000000
        }
      },
      animated_total_throw:function(){
        return this.total_throw.toFixed(0);
      },
      animated_total_cross:function(){
        return this.total_cross.toFixed(0);
      }
    },
    methods:{
      outlier:function(){
        if(this.checkbox){
          this.total_throw = this.real_throw - this.outlier_throw;
          this.total_cross = this.real_cross - this.outlier_cross;
        }else{
          this.total_throw = this.real_throw;
          this.total_cross = this.real_cross;
        }
      }

    },
    created() {
      this.eventHub.$on('factor', (msg)=> {
        console.log(msg)
        this.slider = msg.outrate*100;
      })
      db.collection('data').doc('twmark').onSnapshot({
      
      },(doc) => {
              var twmark = doc.data();
              for (var poi in twmark){
                var element = twmark[poi];
                this.markers[poi]={
                    uid:poi,
                    position:[element.latitude,element.longitude]
                  }
              }
              setTimeout(()=>{ 
                // console.log(this.markers)
                this.eventHub.$emit('firestore',{ markers:this.markers })
              }, 800);
      });
      
      db.collection('data').doc('form').collection('global').doc('TW').onSnapshot({
      },(doc) =>{
              var twtotal = doc.data();
              setTimeout(()=>{ 
                this.real_throw = twtotal.throw;
                this.real_cross = twtotal.cross;

                gsap.to(this.$data, { duration: 0.5, total_throw: twtotal.throw ,total_cross:twtotal.cross});
              }, 800);

      });
      
    }
  }
</script>